<details open>
  <summary #summary translate>photo-help.component.summary</summary>

  <div class="content">
    <div>
      <h3 translate>photo-help.component.instructions</h3>
      <p translate>{{ helpText }}</p>
    </div>

    @if (isFacePhoto) {
      <img src="assets/facecapture.svg" />
    } @else {
      <img src="assets/IDcapture.svg" />
    }

    <button type="button" class="button is-success" (click)="onGotItClick()" translate>
      photo-help.component.got-it
    </button>
  </div>
</details>

<div class="photo-container">
  <ng-content></ng-content>
</div>
